export default __webpack_public_path__ + "static/media/qr-certificate-thumbnail.10cedca9.svg";